module.exports = __webpack_public_path__ + "media/app/assets/specializations/shaman/restoration-143618914bae54e9e7b65548a77a122a.png";